<template>
  <b-modal
    scrollable
    :visible="true"
    :title="title"
    ok-title="Add"
    @hidden="goBack"
    @ok="submit"
  >
    <div v-if="!!identityProvider">
      <b-form-group
        id="idp_name"
        label="Identity Provider Name:"
        label-for="idp_name"
        description=""
      >
        <b-form-input
          id="idp_name"
          v-model="identityProvider.name"
          v-focus
          type="text"
          required
          placeholder="Enter Identity Provider Name"
        />
      </b-form-group>
      <b-form-group
        id="idp_entity_id"
        label="Identity Provider Entity ID:"
        label-for="idp_entity_id"
        description=""
      >
        <b-form-input
          id="idp_entity_id"
          v-model="identityProvider.entity_id"
          type="text"
          required
          placeholder="Enter Entity ID"
        />
      </b-form-group>
      <b-form-group
        id="idp_sso_url"
        label="Identity Provider Single-Sign-On URL:"
        label-for="idp_sso_url"
        description=""
      >
        <b-form-input
          id="idp_sso_url"
          v-model="identityProvider.single_sign_on_url"
          class="fs-exclude"
          type="text"
          required
          placeholder="Enter Single Sign On URL"
        />
      </b-form-group>
      <b-form-group
        id="idp_x509_cert"
        label="Identity Provider X509 Cert:"
        label-for="idp_x509_cert"
        description=""
      >
        <b-form-textarea
          id="idp_x509_cert"
          v-model="identityProvider.idp_cert"
          class="fs-exclude"
          type="text"
          required
          rows="3"
          :placeholder="
            identityProvider.idp_cert_fingerprint ||
            'Enter Identity Provider X509 Certificate'
          "
        />
      </b-form-group>
      <b-form-group
        id="idp_advanced_settings"
        class="fs-exclude"
        label="Advanced Settings for Identity Provider:"
        label-for="idp_advanced_settings"
        description=""
      >
        <b-form-checkbox
          id="signMetadata"
          v-model="identityProvider.sign_metadata"
          name="signMetadata"
          :value="true"
          :unchecked-value="false"
        >
          Sign metadata
        </b-form-checkbox>
        <b-form-checkbox
          id="wantMessagesSigned"
          v-model="identityProvider.want_messages_signed"
          name="wantMessagesSigned"
          :value="true"
          :unchecked-value="false"
        >
          Sign messages
        </b-form-checkbox>
        <b-form-checkbox
          id="authnRequestsSigned"
          v-model="identityProvider.authn_requests_signed"
          name="authnRequestsSigned"
          :value="true"
          :unchecked-value="false"
        >
          Sign AuthN requests
        </b-form-checkbox>
        <b-form-checkbox
          id="wantAssertionsSigned"
          v-model="identityProvider.want_assertions_signed"
          name="wantAssertionsSigned"
          :value="true"
          :unchecked-value="false"
        >
          Assertions from IdP should be signed
        </b-form-checkbox>
        <b-form-checkbox
          id="wantAssertionsEncrypted"
          v-model="identityProvider.want_assertions_encrypted"
          name="wantAssertionsEncrypted"
          :value="true"
          :unchecked-value="false"
        >
          Assertions from IdP should be encrypted
        </b-form-checkbox>
      </b-form-group>
    </div>
  </b-modal>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.rootScreen = from.fullPath === '/';
    });
  },
  props: {
    model: {
      type: Object,
      default: undefined,
    },
    action: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      identityProvider: this.model,
      tag: '',
    };
  },
  methods: {
    submit: function () {
      this.$emit(this.action, this.identityProvider);
    },
    goBack() {
      this.$router.push({
        name: 'saml-settings-view',
      });
    },
  },
};
</script>

<style lang="scss">
.ti-tag {
  background-color: $color-navy-blue !important;
}
</style>
